import { useState, useEffect } from 'react';

interface DovizKurlari {
  rates: Record<string, number>;
  base: string;
  tarih: string;
}

export function useDovizKurlari() {
  const [kurlar, setKurlar] = useState<DovizKurlari | null>(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);

  useEffect(() => {
    const fetchKurlar = async () => {
      setYukleniyor(true);
      try {
        const res = await fetch('https://api.frankfurter.app/latest?from=EUR&to=USD,GBP,TRY');
        if (!res.ok) throw new Error('Kur verisi alınamadı');
        const data = await res.json();
        setKurlar({
          rates: { EUR: 1, ...data.rates },
          base: 'EUR',
          tarih: data.date,
        });
        setHata(null);
      } catch (err) {
        setHata(err instanceof Error ? err.message : 'Bilinmeyen hata');
        setKurlar(null);
      } finally {
        setYukleniyor(false);
      }
    };

    fetchKurlar();
  }, []);

  const cevir = (tutar: number, kaynak: string, hedef: string): number => {
    if (!kurlar || kaynak === hedef) return tutar;
    const rates = kurlar.rates;
    const eur = kaynak === 'EUR' ? tutar : tutar / rates[kaynak];
    return hedef === 'EUR' ? eur : eur * rates[hedef];
  };

  const format = (tutar: number, paraBirimi: string): string => {
    const simge = { EUR: '€', USD: '$', GBP: '£', TL: '₺' }[paraBirimi] || paraBirimi;
    return `${tutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${simge}`;
  };

  return { kurlar, yukleniyor, hata, cevir, format };
}